export const toggleRetailPrice = (newStatus: any) => ({
   type: 'TOGGLE_RETAIL_PRICE',
   payload: newStatus,
 });